import { Component } from '@angular/core';

@Component({
  selector: 'store-card-stencil',
  template: `
    <div class="card-stencil-container">
      <mat-card appearance="outlined" class="card-stencil">
        <div class="card-stencil-header stencil-shimmer"></div>
        <div class="card-stencil-footer">
          <div class="card-stencil-circle stencil-shimmer"></div>
          <div>
            <div class="card-stencil-line-large stencil-shimmer"></div>
            <div class="card-stencil-line-medium stencil-shimmer"></div>
          </div>
        </div>
      </mat-card>
    </div>
  `,
  styleUrls: ['card-stencil.component.scss'],
  standalone: false,
})
export class CardStencilComponent {}
